import React from "react";

export const LazyWormIBChatViewerBridge = React.lazy(
    () => import(/* webpackChunkName: "ChatViewer" */ "./WormIBChatViewer")
);
